export default {
  GPT_BUILDER: 'https://gpt.supster.com/',
}
